import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginSchema } from "../../validations/emailPassword";
import { Input } from "../../Input";
import { Button } from "../../../Buttons/Button";
import { useAuthContext } from "../../../../context/authContext";
import { CLEAR_AUTH_ERROR } from "../../../../reducers/types";
import { Link } from "react-router-dom";

export function LoginForm({ onSubmit, isLoading }) {
  const { dispatch } = useAuthContext();

  const { handleSubmit, control, reset } = useForm({
    resolver: yupResolver(loginSchema),
  });

  useEffect(() => {
    return () => {
      dispatch({ type: CLEAR_AUTH_ERROR });
      reset();
    };
  }, [dispatch, reset]);

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="grid grid-cols-1 gap-y-4 sm:grid-cols-1"
    >
      <div className="sm:col-span-2">
        <Input name="email" label="Email" control={control} inputSize="xl" />
      </div>
      <div className="sm:col-span-2">
        <Input
          name="password"
          label="Password"
          control={control}
          inputSize="xl"
          type="password"
        />
        <div className="mt-1 text-right">
          <Link to="/reset" className="text-blue hover:underline text-sm">
            Forgot Password?
          </Link>
        </div>
      </div>
      <div className="mt-4">
        <Button
          text="Continue"
          type="submit"
          isLoading={isLoading}
          className="w-full flex justify-center min-h-[40px]"
          shape="default"
        />
      </div>
    </form>
  );
}
